
import React from 'react';
import useMobile from '../Hooks/Mobile';

interface IAdaptableTables {
  headers?: string[],
  data: string[][]
}

export default function AdaptableTables({headers, data}: IAdaptableTables) {
  const mobile = useMobile()
  
  const renderLink = (cell: string) => {
    if (cell.includes('http://') || cell.includes('https://')) {
      return (
        <a href={cell} target="_blank" rel='noreferrer'>{ cell }</a>
      )
    }
    return cell
  }

  const renderHeaders = () => {
    if (!headers) return <></>;

    return <tr>
      {
        headers.map(header => (
          <th key={header}>
            <p>{header}</p>
          </th>
        ))
      }
    </tr>
  }

  const renderDataDesktop = () => {
    return data.map((row, index) => (
      <tr key={index}>
        {row.map(cell => (
          <td key={cell}>{ renderLink(cell) }</td>
        ))}
      </tr>
    ))
  }

  const renderDataMobile = () => {
    return data.map((row, index) => (
      <tr key={index}>
        <td colSpan={row.length}>
          { 
            row.map(cell => {
              if (cell.trim() === '') return;
              
              return (
                <div key={cell}>
                  <span>{ renderLink(cell) }</span>
                </div>
              )
            })
          }
        </td>
      </tr>
    ))
  }


  return (
    <>
      { !mobile && 
        renderHeaders()
      }

      { mobile 
        ? renderDataMobile() 
        : renderDataDesktop()
      }
    </>
  )
};
